import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs';
import { Merchant } from '../shared/merchant.model';
import { MonitorService } from '../shared/monitor.service';
import { BsDatepickerConfig, BsDatepickerDirective } from 'ngx-bootstrap/datepicker';
import { ReportService } from '../shared/report.service';
import { DatePipe } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';
import * as $ from 'jquery';
import { HttpClientSecured } from '../services/http-client-secured';
import { ReportFilter } from '../shared/report.filter.model';
import * as myGlobals from '../global';
import { NaturalezaContable } from '../bines/naturaleza-contable';
import { NaturalezasContableService } from '../bines/naturaleza-contable.service';
import { ITarjeta } from '../tarjetas/tarjeta';
import { TarjetasService } from '../tarjetas/tarjetas.service';

@Component({
  selector: 'pm-reportes-view',
  templateUrl: './reportes-view.component.html',
  styleUrls: ['./reportes-view.component.sass']
})
export class ReportesViewComponent implements OnInit, AfterViewInit, OnDestroy {
  public showFilter = false;

  xlsFileUrl = myGlobals.baseApi + '/webadmin/v1/file/';

  // datePickerConfig: Partial<BsDatepickerConfig>;
  datePickerConfig: Partial<BsDatepickerDirective>;
  dataFile: IFileId;
  formData = { dateRange: [new Date(), new Date()] };
  error: boolean;
  errorMessage: string;

  reportFilter: ReportFilter = new ReportFilter();

  retrievalId: string; // S183631522083,
  accountMasked: string; // 6374794826869532,
  operationTypeEnum: string; // PRODUCT_ACTIVATION,
  operationType: string; // Activación,
  posIdentifier: string; // 00038001,
  binCardIssuer: string; // INCOMM,
  serviceName: string; // INCOMM,
  entryMode: string; // Lector de Barras,
  amount: string; // $ 300.00,
  dateTime: number; // 29/12/2018 15:22:52,
  responseCode: string; // 99,
  responseMessage: string; // Denegada;
  merchantName: string; // ,
  merchantId: number; //
  authorizerRM: string; // Unexpected Error,
  authorizerRC: string; // 99,
  approvalCode: string; // ,
  dateTimeId: string; // 20181229,
  product: string; // DIGITAL,
  txnLocalDateTime: string; // 2018-12-29T15:22:52.667,
  status: string; // DENIED_BY_AUTHORIZER

  // private frameworkComponents: any;
  // private noRowsOverlayComponent;
  // private noRowsOverlayComponentParams;

  columnDefs = [
    { headerName: 'Fecha', field: 'txnLocalDateTime', width: 150 },
    { headerName: 'Sucursal', field: 'merchantName', width: 250 },
    { headerName: 'Afiliacion', field: 'affiliation', width: 150 },
    { headerName: 'PDV', field: 'posIdentifier', width: 80 },
    { headerName: 'Caja', field: 'posNumber', width: 80 },
    { headerName: 'Tipo de Operación', field: 'operationType' },
    { headerName: 'Cuenta', field: 'account', width: 120 },
    { headerName: 'Monto', field: 'amount' },
    { headerName: 'Estátus', field: 'status', width: 120 },
    { headerName: 'Respuesta', field: 'responseMessage', width: 240 },
    { headerName: 'Aut RC', field: 'authRC', width: 80 },
    { headerName: 'Folio Aprobación', field: 'approvalCode', width: 150 },
    { headerName: 'Servicio', field: 'serviceName' },
    { headerName: 'Marca de Tarjeta', field: 'cardBrand', width: 150 },
    { headerName: 'Tipo de Tarjeta', field: 'accountingNature', width: 150 },
    { headerName: 'Modo de Entrada', field: 'entryMode', width: 150 },
    { headerName: 'Emisor', field: 'cardIssuerName', width: 150 },
    { headerName: 'Meses', field: 'interestFreeMonths', width: 80 },
    { headerName: 'Referencia', field: 'retrievalId' }
  ];

  defaultColDef = {
    width: 100 /*
    sortable: true,*/,
    resizable: true
  };

  dataSource: any;

  dataGridOptions = {
    pagination: true,
    paginationPageSize: 200,
    overlayLoadingTemplate:
      '<span class="titulos-1">No hay resultados que mostrar, favor de iniciar una búsqueda</span>',
    overlayNoRowsTemplate: '<span class="titulos-1">No hay resultados que mostrar, favor de iniciar una búsqueda</span>'
  };

  merchantList: Merchant[];
  operationStatusList = this.service.getOperationStatus();
  serviceInstanceList = this.service.getServiceInstance();
  operationTypeList = this.service.getOperationTypeCatalog();
  accountingNatureList: Observable<NaturalezaContable[]> = this.accountingNatureService.allRecords();
  cardBrandList: Observable<ITarjeta[]> = this.cardBrandService.getTarjetas();

  constructor(
    public service: ReportService,
    private monitorSvc: MonitorService,
    private http: HttpClientSecured,
    private accountingNatureService: NaturalezasContableService,
    private cardBrandService: TarjetasService,
    private spinnerService: NgxSpinnerService
  ) {
    this.error = false;
  }

  ngOnInit() {
    console.log('ReportesViewComponent: ngOnInit: Incoming...');
    this.reportFilter.merchantId = 'Todas';
    this.reportFilter.status = '0';
    this.reportFilter.serviceId = '0';
    this.reportFilter.operationType = '0';
    this.reportFilter.accountingNature = '';
    this.reportFilter.cardBrand = '';
    this.reportFilter.dateRange = this.formData.dateRange;
    /* this.datePickerConfig = Object.assign(
      {},
      {
        containerClass: 'theme-dark-blue',
        showWeekNumbers: false,
        rangeInputFormat: 'DD/MM/YYYY',
        maxDate: new Date()
      }
    ); */
    this.datePickerConfig = Object.assign(
      {},
      {
        containerClass: 'theme-dark-blue',
        bsValue: new Date(),
        dateInputFormat: 'DD/MM/YYYY',
        maxDate: new Date(),
        showWeekNumbers: false
      }
    );

    this.monitorSvc.getMerchants().subscribe(merchants => {
      this.merchantList = merchants;
      this.reportFilter.merchantObj = merchants[0];
    });
  }

  ngAfterViewInit() {
    $('a[rel=reportes]').addClass('selected');
  }

  filterData() {
    console.log('filterData: Incoming...');
    this.showFilter = true;
  }

  onCreateReportWithoutParams() {
    console.log('onCreateReportWithoutParams: reportFilter: ', this.reportFilter);
    this.onCreateReport(this.reportFilter);
  }

  // onCreateReport(form: any) {
  onCreateReport(pReportFilter: ReportFilter) {
    console.log('onCreateReport: reportFilter: ', pReportFilter);
    this.reportFilter = pReportFilter;
    if (!this.rangeIsValid(pReportFilter)) {
      alert('El rango no puede ser mayor a 90 días');
      return;
    }

    this.spinner();
    this.fillFilterWithDateRange(pReportFilter);

    this.service.getFileID(this.reportFilter).subscribe(
      (res: any) => {
        this.dataFile = res;
        console.log(res);
        // const fileId = this.dataFile['fileId'];
        // const generatedOnline = this.dataFile['generatedOnline'];
        console.log('fileId: ', this.dataFile.fileId);
        console.log('generatedOnline: ', this.dataFile.generatedOnline);
        const xlsFileUrlF = this.xlsFileUrl + this.dataFile.fileId;
        console.log('xlsFileUrlF: ', xlsFileUrlF);
        window.open(this.xlsFileUrl + this.dataFile.fileId);
      },
      err => {
        this.error = true;
        console.log(err);
        console.log(err.error.message);
        alert(err.error.message);
      }
    );
  }

  // rangeIsValid(form: any) {
  rangeIsValid(pReportFilter: ReportFilter) {
    // console.log('rangeIsValid: dateRange: ', JSON.stringify(pReportFilter.dateRange));
    // console.log('rangeIsValid: dateRange[0]: ', pReportFilter.dateRange[0]);
    // console.log('rangeIsValid: dateRange[1]: ', pReportFilter.dateRange[1]);
    const startDate: Date = new Date(pReportFilter.dateRange[0]);
    const endDate: Date = new Date(pReportFilter.dateRange[1]);
    console.log('rangeIsValid: startDate: ', startDate);
    console.log('rangeIsValid: endDate: ', endDate);

    const diff = endDate.getTime() - startDate.getTime();
    const diffDays = diff / (24 * 3600 * 1000);

    if (diffDays > 90) {
      return false;
    }

    return true;
  }

  // fillFilterWithDateRange(form: any) {
  fillFilterWithDateRange(pReportFilter: ReportFilter) {
    const startDate: Date = new Date(pReportFilter.dateRange[0]);
    const endDate: Date = new Date(pReportFilter.dateRange[1]);
    console.log('fillFilterWithDateRange: startDate: ', startDate);
    console.log('fillFilterWithDateRange: endDate: ', endDate);

    // const fmtStartDate = DateFormatter.format(startDate, 'pt', 'yyyy/MM/dd');
    const datePipe = new DatePipe('en-US');
    const fmtStartDate = datePipe.transform(startDate, 'yyyyMMdd');
    console.log('fmtStartDate: ', fmtStartDate);

    const fmtEndDate = datePipe.transform(endDate, 'yyyyMMdd');
    console.log('fmtEndDate: ', fmtEndDate);

    this.reportFilter.startDateId = fmtStartDate;
    this.reportFilter.endDateId = fmtEndDate;

    if (this.reportFilter.merchantObj) {
      this.reportFilter.merchantId = '' + this.reportFilter.merchantObj.id;
    } else {
      this.reportFilter.merchantId = '' + 0;
    }
  }

  // onQueryTxns(form: any) {
  onQueryTxns(pReportFilter: ReportFilter) {
    console.log('onQueryTxns: pReportFilter; ', pReportFilter);
    this.reportFilter = pReportFilter;
    if (!this.rangeIsValid(pReportFilter)) {
      alert('El rango no puede ser mayor a 90 días');
      return;
    }

    this.spinner();

    this.fillFilterWithDateRange(pReportFilter);

    this.dataSource = this.service.getTxnsByFilter(this.reportFilter);
    // console.log('dataSource: ', this.dataSource.);
  }

  public spinner(): void {
    this.spinnerService.show();
    setTimeout(() => {
      this.spinnerService.hide();
    }, 2000);
  }

  ngOnDestroy() {
    $('a[rel=reportes]').removeClass('selected');
  }
}
